export { default as Link } from 'next/link';
export { useRouter, usePathname, redirect } from 'next/navigation';
export const routing = { locales: ['en'] as string[], defaultLocale: 'en' };
